// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"043d1c5d","123":"73a78ecb","588":"5d41cd86","736":"9662fa32","787":"14675f11","841":"113de587","972":"fcab0de1"}[chunkId] + ".chunk.js";
};